import React, { useRef, useState, createContext, useMemo, useCallback } from "react";
import PersonnelListTemplate from "./components/templates/PersonnelListTemplate";
import toISOStringWithTimezone from "../../functions/toISOStringWithTimezone";
import { useLocalStorage } from "../../hooks/localStrage";

export const personnelListContext = createContext();

// モジュール読み込み時に日付が固定化されないよう動的生成関数を定義
const createDefaultFormData = () => {
  const currentDay = new Date();
  const yesterday = new Date(
    currentDay.getFullYear(),
    currentDay.getMonth(),
    currentDay.getDate() - 1
  );

  return {
    fluctuation: false,
    belonging: 0,
    employment: false,
    keyword: "",
    personnel_id: "",
    project_id: "",
    date_from: toISOStringWithTimezone(yesterday).split("T")[0],
    date_to: toISOStringWithTimezone(currentDay).split("T")[0],
    offset: 0,
    score_min: "",
    score_max: "",
    cost_not_set: false,
    cost_min: "",
    cost_max: "",
  };
};

export default function PersonnelListPage() {
  const defaultFormData = useMemo(() => createDefaultFormData(), []);

  // デフォルトの検索条件のために当日と前日の日時を取得する
  const [formdataFromRecruitment, setFormdataFromRecruitment] = useLocalStorage(
    "PersonnelSearchCriteriaFromRecruitment",
    defaultFormData
  );
  const [formdataFromCondition, setFormdataFromCondition] = useLocalStorage(
    "PersonnelSearchCriteriaFromConditions",
    defaultFormData
  );

  const [inputCostMinError, setInputCostMinError] = useState(false);
  const [inputCostMaxError, setInputCostMaxError] = useState(false);
  const inputCostMinRef = useRef(null);
  const inputCostMaxRef = useRef(null);
  const listInnerRef = useRef(null);

  const [isBottom, setIsBottom] = useState(false);
  const [recruitment, setRecruitment] = useState([]);
  const [allCount, setAllCount] = useState(0);
  const [isEndList, setIsEndList] = useState(false);
  const [listFromCondition, setListFromCondition] = useState([]);
  const [listFromRecruitment, setListFromRecruitment] = useState([]);

  // 画面下部へのスクロールを検知（値に変化があった場合のみStateを更新）
  const onScroll = useCallback(() => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      const reachedBottom = scrollTop + clientHeight > scrollHeight - 10;
      setIsBottom((prev) => (prev !== reachedBottom ? reachedBottom : prev));
    }
  }, []);

  // Contextへ渡すオブジェクトをuseMemoでキャッシュ
  const values = useMemo(
    () => ({
      defaultFormData,
      isBottom,
      setIsBottom,
      inputCostMinError,
      setInputCostMinError,
      inputCostMaxError,
      setInputCostMaxError,
      inputCostMinRef,
      inputCostMaxRef,
      recruitment,
      setRecruitment,
      formdataFromRecruitment,
      setFormdataFromRecruitment,
      formdataFromCondition,
      setFormdataFromCondition,
      allCount,
      setAllCount,
      isEndList,
      setIsEndList,
      listFromCondition,
      setListFromCondition,
      listFromRecruitment,
      setListFromRecruitment,
    }),
    [
      defaultFormData,
      isBottom,
      inputCostMinError,
      inputCostMaxError,
      recruitment,
      formdataFromRecruitment,
      formdataFromCondition,
      allCount,
      isEndList,
      listFromCondition,
      listFromRecruitment,
    ]
  );

  return (
    <div
      onScroll={onScroll}
      ref={listInnerRef}
      style={{ height: "100vh", overflowY: "auto", overflowX: "hidden" }}
    >
      <personnelListContext.Provider value={values}>
        <PersonnelListTemplate />
      </personnelListContext.Provider>
    </div>
  );
}